<template>
  <div class="row">
    <div class="col-md-12">
      <label>CATEGORIA</label>
      <treeselect
        :options="[
          { id: '', label: 'NÃO INFORMAR', children: [] },
          ...finance_configuration_category,
        ]"
        placeholder="SELECIONE..."
        v-model="finance_configuration_category_id"
        noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
      />
    </div>
    <div class="col-md-12">
      <errors-messages :errors="errors" />
    </div>
    <div class="col-md-12 text-right">
      <v-btn :disabled="loading" @click="execute" class="btn-save">
        <i class="fas fa-save mr-2 text-twenty"></i>
        {{ loading ? "Carregando" : "SALVAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";

import Treeselect from "@riophae/vue-treeselect";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "FinanceConfigurationCategory",

  components: {
    ErrorsMessages,
    Treeselect,
  },

  props: {
    category_id: { type: [Number, String] },
    hosting_type_value_id: { type: [Number, String] },
    finance_configuration_category: { type: Array },
  },

  data() {
    return {
      finance_configuration_category_id: "",

      loading: false,
      errors: [],
    };
  },

  created() {
    this.finance_configuration_category_id = this.category_id
      ? this.category_id
      : "";
  },

  methods: {
    async execute() {
      try {
        this.loading = true;

        let { hosting_type_value_id, finance_configuration_category_id } = this;

        const data = {
          hosting_type_value_id,
          finance_configuration_category_id,
        };

        const response = await api.put(
          "/rest-home/hosting-type-value/finance-configuration-category",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$emit("success");
          this.$bvModal.hide("finance_configuration_category");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
